import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setState, setModalData } from "@/store/globalSlice"
import { MainButton } from "@/Components/MainButton"
import classNames from "classnames"
import { images } from "@/utils/data"
import { getUserCreds, socket } from "@/utils/utils"
import { useNavigate } from "react-router-dom"

const GameButtonsTop: React.FC = () => {
  const dispatch = useAppDispatch()
  const situationPlayers = useAppSelector(
    (state) => state.global.myGame?.situation?.players
  )
  const currentTurn = useAppSelector(
    (state) => state.global.myGame?.situation?.turn
  )
  const isMobileDevice = useAppSelector((state) => state.global.isMobile)
  const showHistory = useAppSelector((state) => state.global.showHistory)

  const myOrder = situationPlayers?.find(
    (player) => player.id === currentTurn
  )?.order
  const nav = useNavigate()
  const handleOpenPlayerCards = () => {
    if (myOrder !== undefined) {
      dispatch(
        setModalData({
          playerCards: { visible: true, playerOrder: myOrder },
        })
      )
    }
  }

  const handleToggleHistory = () => {
    dispatch(setState({ showHistory: !showHistory }))
  }
  const handleOpenFullStats = () => {
    dispatch(setModalData({ fullStats: { visible: true } }))
  }
  return null

  return (
    <div className="flex gap-4 justify-center">
      {currentTurn === getUserCreds().email && (
        <MainButton
          size={isMobileDevice ? "lg" : "lg"}
          //   disabled={shouldHideRollButton}
          onClick={handleOpenPlayerCards}
          className="max-w-[8rem] w-full"
          data-testid="game.roll-btn"
        >
          <div className="flex items-center gap-2">
            <img className="h-10 w-auto mx-auto" src={images.icons.cards}></img>
            <div className="text-white font-medium font-poppins text-xl hidden">
              Cards
            </div>
          </div>
        </MainButton>
      )}
      <MainButton
        size={isMobileDevice ? "lg" : "lg"}
        //   disabled={shouldHideRollButton}
        onClick={handleOpenFullStats}
        className="max-w-[8rem] w-full"
        data-testid="game.roll-btn"
      >
        <div className="flex items-center gap-2">
          <i className="fa-solid fa-chart-line text-2xl text-white"></i>
          <div className="text-white font-medium font-poppins text-xl hidden">
            Show stats
          </div>
        </div>
      </MainButton>
      {/* <MainButton
        size={isMobileDevice ? "lg" : "lg"}
        onClick={handleToggleHistory}
        className={classNames("max-w-[8rem] w-full", {
          "bg-brown-600": showHistory,
        })}
      >
        <div className="flex items-center gap-2">
          <i className="fa-solid fa-clock-rotate-left text-2xl text-white"></i>
          <div className="text-white font-medium font-poppins text-xl hidden">
            History
          </div>
        </div>
      </MainButton> */}
    </div>
  )
}

export default GameButtonsTop
